<div class="automations" *ngIf="!isFormOpen; else formView">
  <div class="automations__header">
    <h1 class="automations__section-title">Automações da AyA</h1>
    <p class="automations__section-subtitle">
      Deixe a AyA executar uma tarefa recorrente para você.
    </p>
  </div>

  <div
    class="automations__toolbar"
    *ngIf="!isLoading && !hasError && rows.length"
  >
    <button type="button" class="btn btn-primary automations__new" (click)="openCreate()">
      <i class="fas fa-plus" aria-hidden="true"></i>
      Nova automação
    </button>
  </div>

  <div class="automations__list" *ngIf="isLoading">
    <span class="automations__skeleton" *ngFor="let i of skeletonRows"></span>
  </div>

  <div class="automations__placeholder automations__placeholder--error" *ngIf="!isLoading && hasError">
    <span class="automations__placeholder-icon">
      <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
    </span>
    <h3 class="automations__placeholder-title">
      Não foi possível carregar suas automações.
    </h3>
    <p class="automations__placeholder-text">Tente novamente em instantes.</p>
  </div>

  <div class="automations__placeholder" *ngIf="!isLoading && !hasError && !rows.length">
    <h3 class="automations__placeholder-title">
      Você ainda não criou nenhuma automação.
    </h3>
    <p class="automations__placeholder-text">
      Peça à AyA para executar uma tarefa recorrente, como um resumo semanal da
      sua carteira, e ela cuida do resto.
    </p>
    <button type="button" class="btn btn-primary automations__new" (click)="openCreate()">
      <i class="fas fa-plus" aria-hidden="true"></i>
      Nova automação
    </button>
  </div>

  <div class="automations__list" *ngIf="!isLoading && !hasError && rows.length">
    <article
      class="automations__row"
      *ngFor="let row of rows; trackBy: trackByAutomationId"
      [class.automations__row--paused]="
        isPaused(row.automation) && !needsAttention(row.automation)
      "
      [class.automations__row--attention]="needsAttention(row.automation)"
    >
      <div class="automations__main">
        <h3 class="automations__title">
          {{ row.automation.title }}
          <span
            class="automations__chip automations__chip--attention"
            *ngIf="needsAttention(row.automation)"
          >
            <span class="automations__dot"></span>
            Precisa de atenção
          </span>
          <span
            class="automations__chip automations__chip--paused"
            *ngIf="isPaused(row.automation) && !needsAttention(row.automation)"
          >
            <span class="automations__dot"></span>
            Pausada
          </span>
        </h3>

        <p class="automations__desc">{{ row.automation.description }}</p>

        <span
          class="automations__period"
          *ngIf="row.automation.schedule.humanDescription"
        >
          <i class="far fa-clock" aria-hidden="true"></i>
          {{ row.automation.schedule.humanDescription }}
        </span>
      </div>

      <button
        *ngIf="canToggle(row.automation)"
        type="button"
        role="switch"
        class="automations__switch"
        [class.automations__switch--on]="row.active"
        [attr.aria-checked]="row.active"
        [disabled]="row.isBusy"
        [sgtTooltip]="row.active ? 'Pausar' : 'Ativar'"
        tooltipPosition="top"
        [attr.aria-label]="row.active ? 'Pausar automação' : 'Ativar automação'"
        (click)="toggleActive(row, !row.active)"
      >
        <span class="automations__switch-thumb"></span>
      </button>

      <div class="automations__actions">
        <button
          type="button"
          class="automations__action"
          [disabled]="row.isBusy || !canRun(row.automation)"
          [sgtTooltip]="runTooltip(row.automation)"
          tooltipPosition="top"
          aria-label="Executar agora"
          (click)="runNow(row)"
        >
          <i class="fas fa-play" aria-hidden="true"></i>
        </button>

        <button
          type="button"
          class="automations__action"
          *ngIf="canEdit(row.automation)"
          [sgtTooltip]="'Editar'"
          tooltipPosition="top"
          aria-label="Editar"
          (click)="openEdit(row)"
        >
          <i class="far fa-edit" aria-hidden="true"></i>
        </button>

        <sgt-confirm-popover
          *ngIf="canDelete(row.automation)"
          variant="danger"
          message="Excluir esta automação?"
          confirmLabel="Excluir"
          cancelLabel="Cancelar"
          position="bottom"
          (confirmed)="remove(row)"
        >
          <button
            type="button"
            class="automations__action automations__action--danger"
            [disabled]="row.isBusy"
            [sgtTooltip]="'Excluir'"
            tooltipPosition="top"
            aria-label="Excluir"
          >
            <i class="far fa-trash-alt" aria-hidden="true"></i>
          </button>
        </sgt-confirm-popover>
      </div>
    </article>
  </div>
</div>

<ng-template #formView>
  <sgt-automation-form
    [automation]="editingAutomation"
    (saved)="onSaved()"
    (cancelled)="closeForm()"
  ></sgt-automation-form>
</ng-template>
